import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/icon-delete.svg'


const _hoisted_1 = { class: "nav__list nav__list--mobile" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "nav__subtitle" }, "Cart", -1)
const _hoisted_3 = {
  key: 0,
  class: "nav__listCartNotEmpty"
}
const _hoisted_4 = { class: "nav__listShoppingImg" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "nav__listShoppingDetails" }
const _hoisted_7 = { class: "nav__listShoppingName" }
const _hoisted_8 = { class: "nav__listShoppingPrices" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "nav__listShoppingPrices nav__listShoppingPrices--strong" }, "number", -1)
const _hoisted_10 = { class: "nav__iconDelete" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "icon-delete",
  class: "nav__listShoppingDeleteIcon"
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "nav__listCartEmpty"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "nav__listCartEmptyPara" }, "Your cart is empty", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 2,
  class: "nav__check"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _hoisted_2,
    (_ctx.shoes.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shoes, (shoe, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "nav__listShopping",
              key: index
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: shoe.img,
                  alt: shoe.name,
                  class: "nav__imgShopping"
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(shoe.name), 1),
                _createElementVNode("p", _hoisted_8, [
                  _createTextVNode(" $" + _toDisplayString(shoe.price) + " x " + _toDisplayString(shoe.count) + " ", 1),
                  _hoisted_9
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.deleteShoes(index)),
                  class: "nav__listShoppingDelete"
                }, _hoisted_13, 8, _hoisted_11)
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16)),
    (_ctx.shoes.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.restart && _ctx.restart(...args))),
            class: "nav__checkBtn"
          }, "Checkout")
        ]))
      : _createCommentVNode("", true)
  ]))
}